import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermissionKeys, PermissionsService, PermissionState } from '../../../core/service/permissions.service';

/** What the AI chat offers to ask, by the user's permissions in this organisation. */
export const GenericSuggestions = [
  'What are my biggest expenses this month?',
  'Which bills are overdue?',
  'Who are my top suppliers?',
  'How much have I spent in total this year?',
];

/**
 * SD-1244: the chat's starter questions, for what this user may do in this organisation — a
 * Submitter is never offered a Profit and Loss they would be refused. One list for the chat panel
 * and the dashboard's AI strip.
 */
@Injectable({ providedIn: 'root' })
export class AiSuggestionsService {
  readonly suggestions$: Observable<string[]>;

  constructor(permissions: PermissionsService) {
    this.suggestions$ = permissions.state$.pipe(map(state => AiSuggestionsService.forPermissions(state)));
  }

  /** The suggestions for a permission state. Unknown permissions keep the generic list. */
  static forPermissions(state: PermissionState | null, max = 4): string[] {
    if (!state || !state.known) {
      return GenericSuggestions.slice(0, max);
    }
    const has = (key: string) => state.permissions.indexOf(key) >= 0;
    const out: string[] = [];
    if (has(PermissionKeys.financialStatements)) {
      out.push('Show last month\'s Profit and Loss');
    }
    if (has(PermissionKeys.billsView)) {
      out.push('Which bills are due this week?');
    }
    if (has(PermissionKeys.bankingView)) {
      out.push(has(PermissionKeys.bankingViewAll) ? 'Which bank transactions still need reconciling?' : 'Show my bank transactions to reconcile');
    }
    if (has(PermissionKeys.financialStatements)) {
      out.push('What does the Balance Sheet look like at month end?');
    }
    if (has('invoices.view')) {
      out.push('What did we last invoice our biggest customer?');
    }
    out.push('What are my biggest expenses this month?');
    return out.filter((s, i) => out.indexOf(s) === i).slice(0, max);
  }
}
